import navbar from '@/components/navbar/index.vue';
import membernav from '@/components/navbar/memberNav.vue';
import { reactive, toRefs } from 'vue';
import api from '@/assets/js/api';
export default {
  components: {
    navbar,
    membernav
  },
  setup() {
    const data = reactive({}); // 数据
    // const { push } = useRouter()
    const methods = {
      async loadLang() {
        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', 'tw');
        }
      },
      async onload() {
        const res = await api.post('/home', {});
        if (res.data.status === 'M00000') {
          data.serverLink = res.data.result.kf;
          localStorage.setItem('serverLink', res.data.result.kf);
        }
      }
    }; // 事件
    methods.loadLang();
    if (!localStorage.getItem('serverLink')) {
      methods.onload();
    }
    return {
      ...toRefs(data),
      ...methods
    };
  }
};